import { ALL_CUSTOMERS_QUERY } from "../../../graphql/Customers/Customers.graphql";
import { ALL_TARIFFS_QUERY } from "../../../graphql/Tariffs/Tariffs.graphql";
import { ALL_VENDORS_QUERY } from "../../../graphql/Vendors/Vendors.graphql";
import { ALL_PAYMENT_TERMS_QUERY } from "../../../graphql/PaymentTerms/PaymentTerms.graphql";
import { ALL_GL_ACCOUNTS_QUERY } from "../../../graphql/GLMainAccounts/GLMainAccounts.graphql";
import { ALL_COMPANY_POSTING_PERIODS_QUERY } from "../../../graphql/CompanyPostingPeriods/CompanyPostingPeriods.graphql";
import { ALL_ROUTES_VIEW_QUERY } from "../../../graphql/Routes/Routes.graphql";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "Finance",
  label: "Finance",
  icon: "file-invoice",
  permissions: ["FIN"],
  active: location => location.pathname.includes("finance"),
  links: [
    {
      name: "Setup",
      links: [
        {
          name: "Customers",
          to: "/finance/customers",
          query: ALL_CUSTOMERS_QUERY,
          filters: "CUSTOMER_FILTERS"
        },
        {
          name: "GL Accounts",
          to: "/finance/accounts",
          query: ALL_GL_ACCOUNTS_QUERY
        },
        {
          name: "Payment Terms",
          to: "/finance/payment-terms",
          query: ALL_PAYMENT_TERMS_QUERY,
          filters: "PAYMENT_TERMS_FILTERS"
        },
        {
          name: "Posting Periods",
          to: "/finance/posting-periods",
          query: ALL_COMPANY_POSTING_PERIODS_QUERY,
          filters: "COMPANY_POSTING_PERIOD_FILTERS"
        },
        {
          name: "Products",
          to: "/dispatch/products",
          filters: "PRODUCT_FILTERS"
        },
        {
          name: "Routes",
          to: "/dispatch/routes",
          query: ALL_ROUTES_VIEW_QUERY,
          filters: "ROUTE_FILTERS"
        },
        {
          name: "Tariffs",
          to: "/finance/tariffs",
          query: ALL_TARIFFS_QUERY,
          filters: "TARIFF_FILTERS"
        },
        {
          name: "Vendors",
          to: "/fleet/vendors",
          query: ALL_VENDORS_QUERY,
          filters: "VENDOR_FILTERS"
        }
      ]
    },
    {
      name: "Invoice Processing",
      links: [
        {
          name: "Select For Billing",
          to: "/finance/invoice-processing/route-verified"
        },
        {
          name: "Invoice Generation",
          to: "/finance/invoice-generation/billing-verified"
        },
        {
          name: "Invoice Reprint",
          to: "/finance/invoice-reprint"
        },
        {
          name: "Order History",
          to: "/finance/order-history"
        }
      ]
    },
    {
      name: "Reports",
      links: [
        {
          name: "Invoice Edit List",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=InvoiceEditlist`
        },
        {
          name: "Invoice Batch",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Finance%20Historical%20Register`
          // href: ({ invoiceSystemCodes }) =>
          //   Array.isArray(invoiceSystemCodes)
          //     ? `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Finance%20Historical%20Register&Param=OrderStatus&ParamValue=${invoiceSystemCodes
          //         ?.map(({ RecId }) => RecId)
          //         .join(",")}`
          //     : `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Finance%20Historical%20Register`
        },
        {
          name: "Invoice Register",
          href: ({ billedSystemCodes }) =>
            Array.isArray(billedSystemCodes)
              ? `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Finance%20Historical%20Register&Param=OrderStatus&ParamValue=${billedSystemCodes
                  ?.map(({ RecId }) => RecId)
                  .join(",")}`
              : `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Finance%20Historical%20Register`
        },
        {
          name: "Invoice Register List",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Invoice%20Register%20List`
        },
        {
          name: "Invoice Voids",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Voided%20Invoices`
        },
        {
          name: "Driver Work History",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Driver%20Work%20History`
        },
        {
          name: "Load Monthly Count",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Monthly%20Load%20Count`
        },
        {
          name: "Load Monthly Count Details",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Monthly%20Load%20Count%20Detail`
        }
      ]
    }
  ]
};
